var _classCallCheck = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _require = require('readable-stream'),
    Transform = _require.Transform;

var Block = /*#__PURE__*/function (_Transform) {
  "use strict";

  _inherits(Block, _Transform);

  var _super = _createSuper(Block);

  function Block(size) {
    var _this;

    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Block);

    _this = _super.call(this, opts);

    if (typeof size === 'object') {
      opts = size;
      size = opts.size;
    }

    _this.size = size || 512;
    var _opts = opts,
        nopad = _opts.nopad,
        _opts$zeroPadding = _opts.zeroPadding,
        zeroPadding = _opts$zeroPadding === void 0 ? true : _opts$zeroPadding;
    if (nopad) _this._zeroPadding = false;else _this._zeroPadding = !!zeroPadding;
    _this._buffered = [];
    _this._bufferedBytes = 0;
    return _this;
  }

  _createClass(Block, [{
    key: "_transform",
    value: function _transform(buf, enc, next) {
      this._bufferedBytes += buf.length;

      this._buffered.push(buf);

      while (this._bufferedBytes >= this.size) {
        var b = Buffer.concat(this._buffered);
        this._bufferedBytes -= this.size;
        this.push(b.slice(0, this.size));
        this._buffered = [b.slice(this.size, b.length)];
      }

      next();
    }
  }, {
    key: "_flush",
    value: function _flush() {
      if (this._bufferedBytes && this._zeroPadding) {
        var zeroes = Buffer.alloc(this.size - this._bufferedBytes);

        this._buffered.push(zeroes);

        this.push(Buffer.concat(this._buffered));
        this._buffered = null;
      } else if (this._bufferedBytes) {
        this.push(Buffer.concat(this._buffered));
        this._buffered = null;
      }

      this.push(null);
    }
  }]);

  return Block;
}(Transform);

module.exports = Block;